// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabbed_container__20F7-","nav":"Tabbed_nav__1yge6","selected":"Tabbed_selected__1ofSX","content":"Tabbed_content__3KoXz"};